function initBannerVideo() {
  var isDesktop = window.matchMedia('(min-width: 768px)').matches;
  var selector = isDesktop
    ? '.gaganyaan-banner-media--desktop .gaganyaan-banner-video'
    : '.gaganyaan-banner-media--mobile .gaganyaan-banner-video';

  document.querySelectorAll(selector).forEach(function (video) {
    video.preload = 'auto';
    video.play();
  });
}

document.addEventListener('DOMContentLoaded', function () {
  initBannerVideo();

  var hideTimer;

  function showControls(banner) {
    banner.setAttribute('data-show-controls', '');
    clearTimeout(hideTimer);
    hideTimer = setTimeout(function () {
      banner.removeAttribute('data-show-controls');
    }, 2000);
  }

  function togglePlayPause(button) {
    var banner = button.closest('.gaganyaan-banner');
    var videos = banner.querySelectorAll('.gaganyaan-banner-video');
    var isPaused = button.hasAttribute('data-paused');

    videos.forEach(function (video) {
      if (isPaused) {
        video.play();
      } else {
        video.pause();
      }
    });

    if (isPaused) {
      button.removeAttribute('data-paused');
      button.setAttribute('aria-label', 'Pause video');
    } else {
      button.setAttribute('data-paused', '');
      button.setAttribute('aria-label', 'Play video');
    }
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-gaganyaan-play-pause]');
    if (button) {
      togglePlayPause(button);
      showControls(button.closest('.gaganyaan-banner'));
      return;
    }

    var banner = event.target.closest('.gaganyaan-banner');
    if (!banner) return;

    var playPauseBtn = banner.querySelector('[data-gaganyaan-play-pause]');
    if (!playPauseBtn) return;

    togglePlayPause(playPauseBtn);
    showControls(banner);
  });
});
